<template>
  <div class="mod-article-inside">
    <p
      class="detail-title-lv3 pega-pre-wrap"
      data-test="title"
      v-text="title"
    />
    <p
      class="pega-pre-wrap"
      data-test="body"
      v-text="body"
    />
    <div class="mod-image-holder">
      <preview-job-picture
        :photo-id="photoId"
        :alt="title"
        :caption="photoCaption"
        v-on="$listeners"
      />
    </div>
  </div>
</template>

<style scoped lang="scss">
@use "@/styles/preview/sp/base" as *;
</style>

<script>
import PreviewJobPicture from '@/components/atoms/PreviewJobPicture'
export default {
  components: {
    PreviewJobPicture
  },
  props: {
    title: {
      type: String,
      required: true
    },
    body: {
      type: String,
      required: true
    },
    photoId: {
      type: Number,
      required: true
    },
    photoCaption: {
      type: String,
      required: true
    }
  }
}
</script>
